import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { BREEZE_INTELLIGENCE_STARTER_PLATFORM_CARD } from '../../constants/tracking/TrackingSources';
import { useMedia } from '../../hooks/useMedia';
import { FeatureAvailableIcon } from '../feature-table/SharedComponents';
import BuyMoreCredits from './BuyMoreCredits';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BreezeValuePropositions = ({
  screen
}) => {
  const keyFeatures = [I18n.text('pricingPage.pages.breeze-intelligence.keyFeatures.features.dataEnrichment.title'), I18n.text('pricingPage.pages.breeze-intelligence.keyFeatures.features.smartProperties.title'), I18n.text('pricingPage.pages.breeze-intelligence.keyFeatures.features.buyerIntent.title')];
  const isMaxWidthTablet = useMedia('tablet');
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      gap: "800",
      flexDirection: isMaxWidthTablet ? 'column' : 'row',
      alignItems: "center",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "600",
        children: [/*#__PURE__*/_jsx(View, {
          maxInlineSize: "75ch",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h2",
            typography: "heading-400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "merchCards.breezeStarterCustomerPlatformCard.title"
            })
          })
        }), /*#__PURE__*/_jsx(Flex, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.breeze-intelligence.info.banner.description"
          })
        }), /*#__PURE__*/_jsx(Flex, {
          maxInlineSize: "560px",
          justifyContent: "space-between",
          children: keyFeatures.map(message => /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            alignItems: "center",
            flexWrap: "nowrap",
            children: [/*#__PURE__*/_jsx(View, {
              marginInlineEnd: "200",
              children: /*#__PURE__*/_jsx(FeatureAvailableIcon, {
                padding: "100"
              })
            }), /*#__PURE__*/_jsx(Text, {
              whiteSpace: "nowrap",
              as: "p",
              typography: "body-100",
              children: message
            })]
          }, message))
        })]
      }), /*#__PURE__*/_jsx(BuyMoreCredits, {
        screen: screen,
        trackingSource: BREEZE_INTELLIGENCE_STARTER_PLATFORM_CARD
      })]
    })
  });
};
export default BreezeValuePropositions;